export enum RESPONSE_MESSAGE {
  RE_AUTHENTICATION_REQUIRED = 'RE_AUTHENTICATION_REQUIRED',
}
